import api from "./api";
import publicApi from "./publicApi";

export const getBlogs = (params = {}) => {
  return publicApi.get("/blogs/", { params });
};

export const getBlog = (slug) => {
  if (!slug) {
    throw new Error("Blog slug is required");
  }

  return publicApi.get(`/blogs/${slug}/`);
};

export const getFeaturedBlogs = (params = {}) => {
  return publicApi.get("/blogs/featured/", { params });
};

export const searchBlogs = (query) => {
  return publicApi.get("/blogs/search/", {
    params: {
      q: query,
    },
  });
};

export const getCategories = () => {
  return publicApi.get("/blogs/categories/");
};

export const getTags = () => {
  return publicApi.get("/blogs/tags/");
};

export const getRelatedBlogs = (slug) => {
  if (!slug) {
    throw new Error("Blog slug is required");
  }

  return publicApi.get(`/blogs/${slug}/related/`);
};

export const getLikeStatus = (slug, visitorId) => {
  return publicApi.get(`blogs/${slug}/like-status/`, {
    params: { visitor_id: visitorId }
  });
};

export const toggleLikeBlog = (slug, visitorId) => {
  return publicApi.post(`blogs/${slug}/like-toggle/`, {
    visitor_id: visitorId,
  });
};

export const unlikeBlog = (slug, visitorId) => {
  return publicApi.post(`blogs/${slug}/unlike/`, {
    visitor_id: visitorId,
  });
};